export default __webpack_public_path__ + "static/media/offices-highlight.5999fa89.svg";